<template>
    <div class="ws-panel">
        <div class="ws-part">
            <i-col span="6" >
                <ws-pie ref="todoPie" @pieClick="wsClick1"></ws-pie>     
            </i-col>
            <i-col span="6">
                <ws-pie ref="doingPie" @pieClick="wsClick2"></ws-pie> 
            </i-col>
            <i-col span="6">
                <ws-pie ref="implementPie" @pieClick="wsClick3"></ws-pie> 
            </i-col>
            <i-col span="6">
                <ws-pie ref="closedPie" @pieClick="wsClick4"></ws-pie> 
            </i-col>
        </div>
        <div class="ws-part">
            <cs-alarmList :instance="alarmData" ref="alarm"></cs-alarmlist>
        </div>
                        
                   
    </div>
</template>

<script>
    export default {
        name : 'WsPanel',
        props : ['wsprop'],
        data () {
            return {
                alarmData:{
					amount:5,				
					scrollAll:false,
					data:[]
				},
               

            }
        },
        methods : {
            
            //获取工单一览信息
            getWsLevelFPie(){
				this.getApiData('get','/worksheet/levelPieData?status=1',{},res=>{
                    let data={data:res.data.data,legend:[],title:"待处理",total:0}
					res.data.data.forEach((item,index)=>{
						
						data.total+=item.value
					})
					this.$refs.todoPie.reDrawChart(data);
				})
			},
            getWsLevelSPie(){				
				this.getApiData('get','/worksheet/levelPieData?status=2',{},res=>{
                    let data={data:res.data.data,legend:[],title:"处理中",total:0}
					res.data.data.forEach((item,index)=>{
						data.total+=item.value
					})
					this.$refs.doingPie.reDrawChart(data);
				})
			},
            getWsLevelTPie(){				
				this.getApiData('get','/worksheet/levelPieData?status=3',{},res=>{
                    let data={data:res.data.data,legend:[],title:"实施中",total:0}
					res.data.data.forEach((item,index)=>{
						data.total+=item.value
					})
					this.$refs.implementPie.reDrawChart(data);
				})
			},
            getWsLevelFoPie(){				
				this.getApiData('get','/worksheet/levelPieData?status=4',{},res=>{
                    let data={data:res.data.data,legend:[],title:"已关闭",total:0}
					res.data.data.forEach((item,index)=>{						
						data.total+=item.value
					})
					this.$refs.closedPie.reDrawChart(data);
				})
			},
            getAlarmData(){

                this.getApiData('post', '/worksheet/list', {limit:5}, res => {
                    console.log("工单表格"+res.data.worksheetList)
                    this.alarmData.data=res.data.worksheetList;
                })
			 
            },
            wsClick1(data){
                this.$router.push({
                    path : "/repair",
                    name : "repair",
                    params : { "pieData" : data,
                                "status" : 1}
                });
            },
            wsClick2(data){
                this.$router.push({
                    path : "/repair",
                    name : "repair",
                    params : { "pieData" : data,
                                "status" : 2}
                });
            },
            wsClick3(data){
                this.$router.push({
                    path : "/repair",
                    name : "repair",
                    params : { "pieData" : data,
                                "status" : 3}
                });
            },
            wsClick4(data){
                this.$router.push({
                    path : "/repair",
                    name : "repair",
                    params : { "pieData" : data,
                                "status" : 4}
                });
            }            
        },
        mounted() {
                this.getAlarmData();
                this.getWsLevelSPie();
                this.getWsLevelFPie();
                this.getWsLevelTPie();
                this.getWsLevelFoPie();
        }
            
     }
</script>


// WEBPACK FOOTER //
// src/components/panel/WsPanel.vue